// import React, { useState, useCallback, useEffect } from "react";
// import { 
//   FaChartBar, 
//   FaChartPie, 
//   FaCheckCircle, 
//   FaClock, 
//   FaExclamationCircle,
//   FaClipboardCheck,
//   FaCalendarCheck,
//   FaRegCalendarAlt,
//   FaChartLine,
//   FaExclamationTriangle,
//   FaUsers,
//   FaStar,
//   FaUtensils,
//   FaShieldAlt
// } from "react-icons/fa";

// const ComplianceStatus = ({ isMobile }) => {
//     const [complianceData, setComplianceData] = useState({
//         privacyPolicy: { status: "compliant", lastUpdated: "2024-03-15" },
//         termsConditions: { status: "pending", lastUpdated: "2024-02-28" },
//         vendorGuidelines: { status: "non-compliant", lastUpdated: "2024-01-20" },
//         gdpr: { status: "compliant", lastUpdated: "2024-03-10" },
//         dataRetention: { status: "compliant", lastUpdated: "2024-03-05" }
//     });

//     const [vendorId, setVendorId] = useState(null);

//     const getStatusIcon = useCallback((status) => {
//         switch(status) {
//             case 'compliant': return <FaCheckCircle aria-hidden="true" style={{ color: '#4CAF50', marginRight: '5px' }} />;
//             case 'pending': return <FaClock aria-hidden="true" style={{ color: '#FFC107', marginRight: '5px' }} />;
//             case 'non-compliant': return <FaExclamationTriangle aria-hidden="true" style={{ color: '#f44336', marginRight: '5px' }} />;
//             default: return null;
//         }
//     }, []);

//     const getStatusColor = useCallback((status) => {
//         switch(status) {
//             case 'compliant': return '#4CAF50';
//             case 'pending': return '#FFC107';
//             case 'non-compliant': return '#f44336';
//             default: return '#757575';
//         }
//     }, []);

//     useEffect(() => {
//         const storedVendorId = localStorage.getItem("vendorId");
//         if (storedVendorId) {
//             setVendorId(storedVendorId);
//         }
//     }, []);

//     return (
//         <div style={{
//             backgroundColor: "#fff",
//             borderRadius: "10px",
//             padding: isMobile ? "15px" : "25px",
//             border: "1px solid #e0e0e0",
//             minHeight: "400px",
//             overflow: "auto"
//         }}>
//             <h3 style={{ 
//                 color: '#A055B0', 
//                 marginBottom: '25px',
//                 fontSize: isMobile ? '20px' : '24px',
//                 textAlign: 'center',
//                 paddingBottom: '15px',
//                 borderBottom: '3px solid #A055B0'
//             }}>
//                 <FaChartBar aria-hidden="true" style={{ marginRight: '15px' }} />
//                 Food & Beverages Compliance Dashboard
//             </h3>

//             <div style={{ 
//                 padding: '25px', 
//                 borderRadius: '12px',
//                 marginBottom: '10px',
//             }}>
//                 <div style={{
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'center',
//                     flexDirection: isMobile ? 'column' : 'row',
//                     gap: isMobile ? '15px' : '0'
//                 }}>
//                     <div style={{ textAlign: isMobile ? 'center' : 'left' }}>
//                         <h4 style={{ 
//                             fontSize: isMobile ? '18px' : '22px',
//                             color: '#2e7d32',
//                             marginBottom: '10px'
//                         }}>
//                             <FaChartPie aria-hidden="true" style={{ marginRight: '10px' }} />
//                             Overall Food Safety Compliance Score
//                         </h4>
//                         <p style={{ fontSize: isMobile ? '14px' : '16px', color: '#555' }}>
//                             Based on comprehensive assessment of food safety, hygiene, quality standards, and operational excellence
//                         </p>
//                     </div>
//                     <div style={{
//                         textAlign: 'center',
//                         padding: '20px',
//                         border: "1px solid #e0e0e0",
//                         borderRadius: '10px',
//                         minWidth: isMobile ? '100%' : '200px',
//                     }}>
//                         <div style={{
//                             fontSize: isMobile ? '36px' : '48px',
//                             fontWeight: 'bold',
//                             color: '#4CAF50',
//                             marginBottom: '5px'
//                         }}>
//                             94%
//                         </div>
//                         <div style={{ 
//                             fontSize: isMobile ? '14px' : '16px',
//                             color: '#666'
//                         }}>
//                             Excellent Compliance
//                         </div>
//                         <div style={{
//                             fontSize: '12px',
//                             color: '#4CAF50',
//                             marginTop: '5px',
//                             fontWeight: 'bold'
//                         }}>
//                             ▲ 2% from last month
//                         </div>
//                     </div>
//                 </div>
                
//                 <div style={{ marginTop: '25px' }}>
//                     <div style={{ marginBottom: '15px' }}>
//                         <div style={{ 
//                             display: 'flex', 
//                             justifyContent: 'space-between',
//                             marginBottom: '5px'
//                         }}>
//                             <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
//                                 <FaUtensils aria-hidden="true" style={{ marginRight: '5px', color: '#4CAF50' }} />
//                                 Food Safety Standards
//                             </span>
//                             <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#4CAF50' }}>96%</span>
//                         </div>
//                         <div style={{
//                             height: '10px',
//                             backgroundColor: '#e0e0e0',
//                             borderRadius: '5px',
//                             overflow: 'hidden'
//                         }}>
//                             <div style={{
//                                 width: '96%',
//                                 height: '100%',
//                                 backgroundColor: '#4CAF50',
//                                 borderRadius: '5px'
//                             }}></div>
//                         </div>
//                     </div>
                    
//                     <div style={{ marginBottom: '15px' }}>
//                         <div style={{ 
//                             display: 'flex', 
//                             justifyContent: 'space-between',
//                             marginBottom: '5px'
//                         }}>
//                             <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
//                                 <FaShieldAlt aria-hidden="true" style={{ marginRight: '5px', color: '#2196F3' }} />
//                                 Hygiene & Sanitation
//                             </span>
//                             <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#2196F3' }}>92%</span>
//                         </div>
//                         <div style={{
//                             height: '10px',
//                             backgroundColor: '#e0e0e0',
//                             borderRadius: '5px',
//                             overflow: 'hidden'
//                         }}>
//                             <div style={{
//                                 width: '92%',
//                                 height: '100%',
//                                 backgroundColor: '#2196F3',
//                                 borderRadius: '5px'
//                             }}></div>
//                         </div>
//                     </div>
                    
//                     <div style={{ marginBottom: '15px' }}>
//                         <div style={{ 
//                             display: 'flex', 
//                             justifyContent: 'space-between',
//                             marginBottom: '5px'
//                         }}>
//                             <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
//                                 <FaStar aria-hidden="true" style={{ marginRight: '5px', color: '#FF9800' }} />
//                                 Quality Control
//                             </span>
//                             <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#FF9800' }}>91%</span>
//                         </div>
//                         <div style={{
//                             height: '10px',
//                             backgroundColor: '#e0e0e0',
//                             borderRadius: '5px',
//                             overflow: 'hidden'
//                         }}>
//                             <div style={{
//                                 width: '91%',
//                                 height: '100%',
//                                 backgroundColor: '#FF9800',
//                                 borderRadius: '5px'
//                             }}></div>
//                         </div>
//                     </div>

//                     <div style={{ marginBottom: '15px' }}>
//                         <div style={{ 
//                             display: 'flex', 
//                             justifyContent: 'space-between',
//                             marginBottom: '5px'
//                         }}>
//                             <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
//                                 <FaClipboardCheck aria-hidden="true" style={{ marginRight: '5px', color: '#9C27B0' }} />
//                                 Operational Excellence
//                             </span>
//                             <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#9C27B0' }}>88%</span>
//                         </div>
//                         <div style={{
//                             height: '10px',
//                             backgroundColor: '#e0e0e0',
//                             borderRadius: '5px',
//                             overflow: 'hidden'
//                         }}>
//                             <div style={{
//                                 width: '88%',
//                                 height: '100%',
//                                 backgroundColor: '#9C27B0',
//                                 borderRadius: '5px'
//                             }}></div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <div style={{ 
//                 marginBottom: '10px',
//                 padding: '20px',
//                 borderRadius: '10px',
//             }}>
//                 <h4 style={{ 
//                     fontSize: isMobile ? '16px' : '18px',
//                     color: '#333',
//                     marginBottom: '15px',
//                     textAlign: 'center'
//                 }}>
//                     🍽️ Food & Beverages Compliance Categories
//                 </h4>
//                 <div style={{
//                     display: 'grid',
//                     gridTemplateColumns: isMobile ? '1fr' : 'repeat(4, 1fr)',
//                     gap: '15px',
//                     marginBottom: '20px'
//                 }}>
//                     {[
//                         { 
//                             id: 'food-safety', 
//                             name: 'Food Safety', 
//                             description: 'Temperature control, storage, handling',
//                             icon: <FaShieldAlt aria-hidden="true" />, 
//                             color: '#4CAF50',
//                             score: '96%'
//                         },
//                         { 
//                             id: 'hygiene', 
//                             name: 'Hygiene Standards', 
//                             description: 'Staff hygiene, sanitation, cleaning',
//                             icon: <FaUsers aria-hidden="true" />, 
//                             color: '#2196F3',
//                             score: '92%'
//                         },
//                         { 
//                             id: 'quality', 
//                             name: 'Quality Control', 
//                             description: 'Ingredients, preparation, consistency',
//                             icon: <FaStar aria-hidden="true" />, 
//                             color: '#FF9800',
//                             score: '91%'
//                         },
//                         { 
//                             id: 'operations', 
//                             name: 'Operations', 
//                             description: 'Service, documentation, training',
//                             icon: <FaClipboardCheck aria-hidden="true" />, 
//                             color: '#9C27B0',
//                             score: '88%'
//                         }
//                     ].map(category => (
//                         <div 
//                             key={category.id}
//                             style={{
//                                 padding: '20px',
//                                 borderRadius: '8px',
//                                 textAlign: 'center',
//                                 border: `1px solid ${category.color}`,
//                                 transition: 'all 0.3s ease',
//                                 cursor: 'pointer'
//                             }}
//                             onMouseEnter={(e) => {
//                                 e.currentTarget.style.transform = 'translateY(-5px)';
//                             }}
//                             onMouseLeave={(e) => {
//                                 e.currentTarget.style.transform = 'translateY(0)';
//                             }}
//                             onClick={() => alert(`View ${category.name} details`)}
//                         >
//                             <div style={{ 
//                                 fontSize: '32px', 
//                                 color: category.color,
//                                 marginBottom: '15px'
//                             }}>
//                                 {category.icon}
//                             </div>
//                             <div style={{ 
//                                 fontSize: isMobile ? '16px' : '18px',
//                                 fontWeight: 'bold',
//                                 color: '#333',
//                                 marginBottom: '8px'
//                             }}>
//                                 {category.name}
//                             </div>
//                             <div style={{ 
//                                 fontSize: isMobile ? '12px' : '13px',
//                                 color: '#666',
//                                 marginBottom: '15px',
//                                 minHeight: '40px'
//                             }}>
//                                 {category.description}
//                             </div>
//                             <div style={{
//                                 fontSize: '24px',
//                                 fontWeight: 'bold',
//                                 color: category.color,
//                                 padding: '8px',
//                                 borderRadius: '6px'
//                             }}>
//                                 {category.score}
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>

//             <div style={{ 
//                 display: 'grid', 
//                 gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)', 
//                 gap: '20px', 
//                 marginBottom: '10px' 
//             }}>
//                 {[
//                     { 
//                         title: "Temperature Control", 
//                         status: "compliant", 
//                         score: "98%",
//                         icon: <FaCheckCircle aria-hidden="true" />,
//                         color: "#4CAF50",
//                         lastCheck: "Today",
//                         details: "Refrigeration, cooking, holding temperatures",
//                         trend: "▲ 1%"
//                     },
//                     { 
//                         title: "Staff Hygiene", 
//                         status: "compliant", 
//                         score: "95%",
//                         icon: <FaClipboardCheck aria-hidden="true" />,
//                         color: "#4CAF50",
//                         lastCheck: "2 days ago",
//                         details: "Hand washing, uniform, health checks",
//                         trend: "▲ 2%"
//                     },
//                     { 
//                         title: "Ingredient Quality", 
//                         status: "compliant", 
//                         score: "96%",
//                         icon: <FaStar aria-hidden="true" />,
//                         color: "#4CAF50",
//                         lastCheck: "Yesterday",
//                         details: "Freshness, sourcing, storage",
//                         trend: "▲ 3%"
//                     },
//                     { 
//                         title: "Food Storage", 
//                         status: "pending", 
//                         score: "88%",
//                         icon: <FaClock aria-hidden="true" />,
//                         color: "#FFC107",
//                         lastCheck: "1 week ago",
//                         details: "FIFO, labeling, segregation",
//                         trend: "▼ 2%"
//                     },
//                     { 
//                         title: "Preparation Standards", 
//                         status: "compliant", 
//                         score: "94%",
//                         icon: <FaCheckCircle aria-hidden="true" />,
//                         color: "#4CAF50",
//                         lastCheck: "3 days ago",
//                         details: "Cooking methods, cross-contamination",
//                         trend: "▲ 1%"
//                     },
//                     { 
//                         title: "Cleaning Procedures", 
//                         status: "attention", 
//                         score: "82%",
//                         icon: <FaExclamationCircle aria-hidden="true" />,
//                         color: "#f44336",
//                         lastCheck: "2 weeks ago",
//                         details: "Sanitization, equipment cleaning",
//                         trend: "▼ 5%"
//                     }
//                 ].map((item, index) => (
//                     <div 
//                         key={index} 
//                         style={{
//                             backgroundColor: "#fff",
//                             borderRadius: "8px",
//                             padding: "15px",
//                             minHeight: "100px",
//                             border: "1px solid #e0e0e0",
//                             borderLeft: `5px solid ${item.color}`,
//                             transition: 'all 0.3s ease',
//                             cursor: 'pointer',
//                             position: 'relative'
//                         }}
//                         onMouseEnter={(e) => {
//                             e.currentTarget.style.transform = 'translateY(-5px)';
//                         }}
//                         onMouseLeave={(e) => {
//                             e.currentTarget.style.transform = 'translateY(0)';
//                         }}
//                         onClick={() => alert(`View details for ${item.title}`)}
//                     >
//                         <div style={{ 
//                             display: 'flex', 
//                             justifyContent: 'space-between', 
//                             alignItems: 'flex-start',
//                             marginBottom: '15px'
//                         }}>
//                             <div style={{ flex: 1 }}>
//                                 <h5 style={{ 
//                                     margin: '0 0 5px 0', 
//                                     color: '#333',
//                                     fontSize: isMobile ? '14px' : '16px',
//                                     fontWeight: 'bold'
//                                 }}>
//                                     {item.title}
//                                 </h5>
//                                 <div style={{ 
//                                     display: 'flex', 
//                                     alignItems: 'center',
//                                     marginBottom: '5px'
//                                 }}>
//                                     <span style={{ 
//                                         color: item.color,
//                                         fontWeight: 'bold',
//                                         fontSize: isMobile ? '18px' : '22px',
//                                         marginRight: '10px'
//                                     }}>
//                                         {item.score}
//                                     </span>
//                                     <span style={{ 
//                                         color: item.color,
//                                         padding: '3px 8px',
//                                         borderRadius: '12px',
//                                         fontSize: '11px',
//                                         fontWeight: 'bold',
//                                         textTransform: 'uppercase'
//                                     }}>
//                                         {item.status}
//                                     </span>
//                                 </div>
//                                 <div style={{ 
//                                     fontSize: '12px',
//                                     color: '#666',
//                                     marginTop: '8px',
//                                     lineHeight: '1.4'
//                                 }}>
//                                     {item.details}
//                                 </div>
//                             </div>
//                             <div style={{ 
//                                 fontSize: '24px', 
//                                 color: item.color,
//                                 marginLeft: '10px'
//                             }}>
//                                 {item.icon}
//                             </div>
//                         </div>
                        
//                         <div style={{ 
//                             display: 'flex', 
//                             justifyContent: 'space-between',
//                             alignItems: 'center',
//                             fontSize: '12px',
//                             color: '#666',
//                             marginTop: '15px',
//                             paddingTop: '10px',
//                             borderTop: '1px solid #f0f0f0'
//                         }}>
//                             <div style={{ display: 'flex', alignItems: 'center' }}>
//                                 <FaRegCalendarAlt aria-hidden="true" style={{ marginRight: '5px', fontSize: '10px' }} />
//                                 Checked: {item.lastCheck}
//                             </div>
//                             <div style={{
//                                 color: item.trend.startsWith('▲') ? '#4CAF50' : 
//                                        item.trend.startsWith('▼') ? '#f44336' : '#666',
//                                 fontWeight: 'bold'
//                             }}>
//                                 {item.trend}
//                             </div>
//                         </div>
//                     </div>
//                 ))}
//             </div>

//             <div style={{ 
//                 padding: '25px', 
//                 borderRadius: '12px',
//                 marginBottom: '10px',
//             }}>
//                 <h4 style={{ 
//                     fontSize: isMobile ? '18px' : '20px',
//                     color: '#1565c0',
//                     marginBottom: '20px',
//                     display: 'flex',
//                     alignItems: 'center'
//                 }}>
//                     <FaCalendarCheck aria-hidden="true" style={{ marginRight: '10px' }} />
//                     Upcoming Food Safety Audits & Inspections
//                 </h4>
                
//                 <div style={{
//                     display: 'grid',
//                     gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
//                     gap: '15px'
//                 }}>
//                     {[
//                         { 
//                             title: "FSSAI Annual Inspection", 
//                             date: "2024-04-15", 
//                             status: "scheduled",
//                             type: "Regulatory",
//                             priority: "high",
//                             inspector: "Food Safety Officer",
//                             location: "Main Kitchen"
//                         },
//                         { 
//                             title: "Kitchen Hygiene Audit", 
//                             date: "2024-04-22", 
//                             status: "scheduled",
//                             type: "Internal",
//                             priority: "medium",
//                             inspector: "Quality Manager",
//                             location: "All Areas"
//                         },
//                         { 
//                             title: "Staff Training Assessment", 
//                             date: "2024-05-01", 
//                             status: "pending",
//                             type: "Training",
//                             priority: "medium",
//                             inspector: "Training Department",
//                             location: "Training Room"
//                         },
//                         { 
//                             title: "Supplier Quality Review", 
//                             date: "2024-05-10", 
//                             status: "planned",
//                             type: "Vendor",
//                             priority: "high",
//                             inspector: "Procurement Team",
//                             location: "Storage & Kitchen"
//                         }
//                     ].map((audit, index) => (
//                         <div 
//                             key={index}
//                             style={{
//                                 padding: '20px',
//                                 borderRadius: '8px',
//                                 border: '1px solid #e0e0e0'
//                             }}
//                         >
//                             <div style={{ 
//                                 display: 'flex', 
//                                 justifyContent: 'space-between',
//                                 alignItems: 'flex-start',
//                                 marginBottom: '10px',
//                                 flexDirection: isMobile ? 'column' : 'row',
//                                 gap: isMobile ? '8px' : '0'
//                             }}>
//                                 <div style={{ flex: 1 }}>
//                                     <h6 style={{ 
//                                         margin: 0,
//                                         fontSize: isMobile ? '14px' : '16px',
//                                         fontWeight: 'bold',
//                                         color: '#333',
//                                         lineHeight: '1.3'
//                                     }}>
//                                         {audit.title}
//                                     </h6>
//                                     <div style={{ 
//                                         fontSize: isMobile ? '11px' : '12px',
//                                         color: '#666',
//                                         marginTop: isMobile ? '3px' : '5px'
//                                     }}>
//                                         <div>Inspector: {audit.inspector}</div>
//                                         <div>Location: {audit.location}</div>
//                                     </div>
//                                 </div>
//                                 <span style={{ 
//                                     color: audit.status === 'scheduled' ? '#2e7d32' : 
//                                            audit.status === 'pending' ? '#FF9800' : '#2196F3',
//                                     padding: '4px 10px',
//                                     borderRadius: '12px',
//                                     fontSize: isMobile ? '10px' : '12px',
//                                     fontWeight: 'bold',
//                                     whiteSpace: 'nowrap',
//                                     alignSelf: isMobile ? 'flex-start' : 'center'
//                                 }}>
//                                     {audit.status.toUpperCase()}
//                                 </span>
//                             </div>
//                             <div style={{ 
//                                 display: 'flex', 
//                                 justifyContent: 'space-between',
//                                 alignItems: 'center',
//                                 fontSize: isMobile ? '11px' : '13px',
//                                 color: '#666',
//                                 marginTop: '15px',
//                                 flexDirection: isMobile ? 'column' : 'row',
//                                 gap: isMobile ? '8px' : '0',
//                                 alignItems: isMobile ? 'flex-start' : 'center'
//                             }}>
//                                 <div style={{ display: 'flex', alignItems: 'center' }}>
//                                     <FaRegCalendarAlt aria-hidden="true" style={{ marginRight: '8px', fontSize: isMobile ? '12px' : '14px' }} />
//                                     <strong>Date:</strong> {audit.date}
//                                 </div>
//                                 <div style={{ alignSelf: isMobile ? 'flex-start' : 'center' }}>
//                                     <span style={{ 
//                                         color: audit.priority === 'high' ? '#f44336' : 
//                                                audit.priority === 'medium' ? '#FF9800' : '#4CAF50',
//                                         padding: '4px 8px',
//                                         borderRadius: '10px',
//                                         fontSize: isMobile ? '10px' : '11px',
//                                         fontWeight: 'bold',
//                                         display: 'inline-block',
//                                         textAlign: 'center'
//                                     }}>
//                                         {audit.type} | {audit.priority.toUpperCase()} PRIORITY
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>

//             <div style={{ 
//                 padding: '25px', 
//                 borderRadius: '12px',
//                 marginBottom: '10px',
//             }}>
//                 <h4 style={{ 
//                     fontSize: isMobile ? '18px' : '20px',
//                     color: '#e65100',
//                     marginBottom: '20px',
//                     display: 'flex',
//                     alignItems: 'center'
//                 }}>
//                     <FaClipboardCheck aria-hidden="true" style={{ marginRight: '10px' }} />
//                     Required Actions for Food Safety Compliance
//                 </h4>
                
//                 <div style={{
//                     display: 'grid',
//                     gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
//                     gap: '15px',
//                     marginBottom: '20px'
//                 }}>
//                     <div style={{ padding: '20px', borderRadius: '8px', border: '1px solid #e0e0e0' }}>
//                         <div style={{ 
//                             display: 'flex', 
//                             alignItems: 'center',
//                             marginBottom: '15px'
//                         }}>
//                             <FaExclamationTriangle aria-hidden="true" style={{ color: '#f44336', marginRight: '10px', fontSize: '20px' }} />
//                             <strong style={{ color: '#f44336', fontSize: isMobile ? '14px' : '16px' }}>
//                                 Immediate Attention Required (Within 48 hours)
//                             </strong>
//                         </div>
//                         <ul style={{ paddingLeft: '20px', fontSize: '14px', margin: 0 }}>
//                             <li style={{ marginBottom: '8px', paddingLeft: '10px' }}>
//                                 <strong>Deep Cleaning Schedule:</strong> Complete overdue deep cleaning of walk-in refrigerator
//                             </li>
//                             <li style={{ marginBottom: '8px', paddingLeft: '10px' }}>
//                                 <strong>Temperature Logs:</strong> Submit missing temperature logs for March 15-20
//                             </li>
//                             <li style={{ marginBottom: '8px', paddingLeft: '10px' }}>
//                                 <strong>Staff Training:</strong> 2 kitchen staff need food handler certification renewal
//                             </li>
//                             <li style={{ paddingLeft: '10px' }}>
//                                 <strong>Equipment Calibration:</strong> Calibrate meat thermometer by tomorrow
//                             </li>
//                         </ul>
//                     </div>
                    
//                     <div style={{ padding: '20px', borderRadius: '8px', border: '1px solid #e0e0e0' }}>
//                         <div style={{ 
//                             display: 'flex', 
//                             alignItems: 'center',
//                             marginBottom: '15px'
//                         }}>
//                             <FaClock aria-hidden="true" style={{ color: '#FF9800', marginRight: '10px', fontSize: '20px' }} />
//                             <strong style={{ color: '#FF9800', fontSize: isMobile ? '14px' : '16px' }}>
//                                 Upcoming Compliance Deadlines
//                             </strong>
//                         </div>
//                         <ul style={{ paddingLeft: '20px', fontSize: '14px', margin: 0 }}>
//                             <li style={{ marginBottom: '8px', paddingLeft: '10px' }}>
//                                 <strong>Q1 Safety Report:</strong> Due April 30, 2024
//                             </li>
//                             <li style={{ marginBottom: '8px', paddingLeft: '10px' }}>
//                                 <strong>Pest Control Service:</strong> Scheduled for May 5, 2024
//                             </li>
//                             <li style={{ marginBottom: '8px', paddingLeft: '10px' }}>
//                                 <strong>Fire Safety Inspection:</strong> Due May 15, 2024
//                             </li>
//                             <li style={{ paddingLeft: '10px' }}>
//                                 <strong>Annual Staff Health Check:</strong> Due June 1, 2024
//                             </li>
//                         </ul>
//                     </div>
//                 </div>
                
//                 <div style={{ textAlign: 'center' }}>
//                     <button 
//                         onClick={() => alert("Generate Food Safety Report clicked")}
//                         style={{
//                             backgroundColor: '#4CAF50',
//                             color: 'white',
//                             border: 'none',
//                             padding: isMobile ? '10px 20px' : '15px 40px',
//                             borderRadius: '50px',
//                             cursor: 'pointer',
//                             fontSize: isMobile ? '14px' : '16px',
//                             fontWeight: 'bold',
//                             minWidth: isMobile ? '200px' : '250px',
//                             maxWidth: isMobile ? '90%' : 'none',
//                             display: 'inline-flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             transition: 'all 0.3s ease',
//                             boxShadow: '0 4px 15px rgba(76, 175, 80, 0.3)',
//                             height: isMobile ? '45px' : '50px'
//                         }}
//                         onMouseEnter={(e) => {
//                             e.currentTarget.style.backgroundColor = '#388E3C';
//                             e.currentTarget.style.transform = 'translateY(-2px)';
//                             e.currentTarget.style.boxShadow = '0 6px 20px rgba(76, 175, 80, 0.4)';
//                         }}
//                         onMouseLeave={(e) => {
//                             e.currentTarget.style.backgroundColor = '#4CAF50';
//                             e.currentTarget.style.transform = 'translateY(0)';
//                             e.currentTarget.style.boxShadow = '0 4px 15px rgba(76, 175, 80, 0.3)';
//                         }}
//                     >
//                         <FaChartBar aria-hidden="true" style={{ marginRight: '10px', fontSize: isMobile ? '16px' : '18px' }} />
//                         Generate Compliance Report
//                     </button>
//                 </div>
//             </div>

//             <div style={{ 
//                 padding: '15px', 
//                 borderRadius: '12px',
//                 marginBottom: '10px',
//             }}>
//                 <h4 style={{ 
//                     fontSize: isMobile ? '18px' : '20px',
//                     color: '#7b1fa2',
//                     marginBottom: '20px',
//                     display: 'flex',
//                     alignItems: 'center'
//                 }}>
//                     <FaChartLine aria-hidden="true" style={{ marginRight: '10px' }} />
//                     Food Safety Performance Metrics
//                 </h4>
                
//                 <div style={{
//                     display: 'grid',
//                     gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
//                     gap: '15px'
//                 }}>
//                     <div style={{ 
//                         textAlign: 'center', 
//                         padding: '20px', 
//                         borderRadius: '8px',
//                         border: '1px solid #e0e0e0'
//                     }}>
//                         <div style={{ fontSize: isMobile ? '28px' : '32px', color: '#4CAF50', fontWeight: 'bold', marginBottom: '10px' }}>0</div>
//                         <div style={{ fontSize: isMobile ? '12px' : '14px', color: '#666', marginBottom: '5px' }}>Critical Violations</div>
//                         <div style={{ fontSize: '12px', color: '#4CAF50', fontWeight: 'bold' }}>This Month</div>
//                     </div>
//                     <div style={{ 
//                         textAlign: 'center', 
//                         padding: '20px', 
//                         borderRadius: '8px',
//                         border: '1px solid #e0e0e0'
//                     }}>
//                         <div style={{ fontSize: isMobile ? '28px' : '32px', color: '#2196F3', fontWeight: 'bold', marginBottom: '10px' }}>3</div>
//                         <div style={{ fontSize: isMobile ? '12px' : '14px', color: '#666', marginBottom: '5px' }}>Minor Violations</div>
//                         <div style={{ fontSize: '12px', color: '#2196F3', fontWeight: 'bold' }}>Resolving</div>
//                     </div>
//                     <div style={{ 
//                         textAlign: 'center', 
//                         padding: '20px', 
//                         borderRadius: '8px',
//                         border: '1px solid #e0e0e0'
//                     }}>
//                         <div style={{ fontSize: isMobile ? '28px' : '32px', color: '#FF9800', fontWeight: 'bold', marginBottom: '10px' }}>12</div>
//                         <div style={{ fontSize: isMobile ? '12px' : '14px', color: '#666', marginBottom: '5px' }}>Completed Audits</div>
//                         <div style={{ fontSize: '12px', color: '#FF9800', fontWeight: 'bold' }}>Last 90 Days</div>
//                     </div>
//                     <div style={{ 
//                         textAlign: 'center', 
//                         padding: '20px', 
//                         borderRadius: '8px',
//                         border: '1px solid #e0e0e0'
//                     }}>
//                         <div style={{ fontSize: isMobile ? '28px' : '32px', color: '#9C27B0', fontWeight: 'bold', marginBottom: '10px' }}>94%</div>
//                         <div style={{ fontSize: isMobile ? '12px' : '14px', color: '#666', marginBottom: '5px' }}>Compliance Score</div>
//                         <div style={{ fontSize: '12px', color: '#9C27B0', fontWeight: 'bold' }}>Industry Average: 89%</div>
//                     </div>
//                 </div>
//             </div>

//             <div style={{ 
//                 padding: '25px', 
//                 borderRadius: '12px',
//                 textAlign: 'center'
//             }}>
//                 <h4 style={{ 
//                     fontSize: isMobile ? '18px' : '20px',
//                     color: '#2e7d32',
//                     marginBottom: '15px'
//                 }}>
//                     🏆 Compliance Excellence Recognition
//                 </h4>
//                 <p style={{ fontSize: isMobile ? '14px' : '16px', color: '#333', marginBottom: '20px' }}>
//                     Your establishment maintains <strong>94% compliance score</strong>, placing you in the <strong>top 15%</strong> 
//                     of Food & Beverage businesses on our platform. Keep up the excellent work!
//                 </p>
//                 <div style={{
//                     display: 'flex',
//                     justifyContent: 'center',
//                     gap: '20px',
//                     flexWrap: 'wrap'
//                 }}>
//                     <div style={{ 
//                         padding: '15px', 
//                         borderRadius: '8px',
//                         minWidth: isMobile ? '130px' : '150px',
//                         border: '1px solid #e0e0e0'
//                     }}>
//                         <div style={{ fontSize: '12px', color: '#666', marginBottom: '5px' }}>Current Streak</div>
//                         <div style={{ fontSize: '24px', color: '#4CAF50', fontWeight: 'bold' }}>180</div>
//                         <div style={{ fontSize: '12px', color: '#666' }}>Days without violations</div>
//                     </div>
//                     <div style={{ 
//                         padding: '15px', 
//                         borderRadius: '8px',
//                         minWidth: isMobile ? '130px' : '150px',
//                         border: '1px solid #e0e0e0'
//                     }}>
//                         <div style={{ fontSize: '12px', color: '#666', marginBottom: '5px' }}>Industry Rank</div>
//                         <div style={{ fontSize: '24px', color: '#4CAF50', fontWeight: 'bold' }}>Top 15%</div>
//                         <div style={{ fontSize: '12px', color: '#666' }}>Among 500+ restaurants</div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default ComplianceStatus;



import React, { useState, useCallback, useEffect } from "react";
import { 
  FaChartBar, 
  FaChartPie, 
  FaCheckCircle, 
  FaClock, 
  FaExclamationCircle,
  FaClipboardCheck,
  FaCalendarCheck,
  FaRegCalendarAlt,
  FaChartLine,
  FaExclamationTriangle,
  FaUsers,
  FaStar,
  FaUtensils,
  FaShieldAlt
} from "react-icons/fa";

const ComplianceStatus = ({ isMobile }) => {
    const [complianceData, setComplianceData] = useState({
        privacyPolicy: { status: "compliant", lastUpdated: "2024-03-15" },
        termsConditions: { status: "pending", lastUpdated: "2024-02-28" },
        vendorGuidelines: { status: "non-compliant", lastUpdated: "2024-01-20" },
        gdpr: { status: "compliant", lastUpdated: "2024-03-10" },
        dataRetention: { status: "compliant", lastUpdated: "2024-03-05" }
    });

    const [vendorId, setVendorId] = useState(null);

    const getStatusIcon = useCallback((status) => {
        switch(status) {
            case 'compliant': return <FaCheckCircle aria-hidden="true" style={{ color: '#4CAF50', marginRight: '5px' }} />;
            case 'pending': return <FaClock aria-hidden="true" style={{ color: '#FFC107', marginRight: '5px' }} />;
            case 'non-compliant': return <FaExclamationTriangle aria-hidden="true" style={{ color: '#f44336', marginRight: '5px' }} />;
            default: return null;
        }
    }, []);

    const getStatusColor = useCallback((status) => {
        switch(status) {
            case 'compliant': return '#4CAF50';
            case 'pending': return '#FFC107';
            case 'non-compliant': return '#f44336';
            default: return '#757575';
        }
    }, []);

    useEffect(() => {
        const storedVendorId = localStorage.getItem("vendorId");
        if (storedVendorId) {
            setVendorId(storedVendorId);
        }
    }, []);

    return (
        <div style={{
            backgroundColor: "#fff",
            borderRadius: "10px",
            padding: isMobile ? "15px" : "25px",
            border: "1px solid #e0e0e0",
            minHeight: "400px",
            overflow: "auto"
        }}>
            <h3 style={{ 
                color: '#A055B0', 
                marginBottom: '25px',
                fontSize: isMobile ? '20px' : '24px',
                textAlign: 'center',
                paddingBottom: '15px',
                borderBottom: '3px solid #A055B0'
            }}>
                <FaChartBar aria-hidden="true" style={{ marginRight: '15px' }} />
                Food & Beverages Compliance Dashboard
            </h3>

            <div style={{ 
                padding: '25px', 
                borderRadius: '12px',
                marginBottom: '10px',
            }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexDirection: isMobile ? 'column' : 'row',
                    gap: isMobile ? '15px' : '0'
                }}>
                    <div style={{ textAlign: isMobile ? 'center' : 'left' }}>
                        <h4 style={{ 
                            fontSize: isMobile ? '18px' : '22px',
                            color: '#2e7d32',
                            marginBottom: '10px'
                        }}>
                            <FaChartPie aria-hidden="true" style={{ marginRight: '10px' }} />
                            Overall Food Safety Compliance Score
                        </h4>
                        <p style={{ fontSize: isMobile ? '14px' : '16px', color: '#555' }}>
                            Based on comprehensive assessment of food safety, hygiene, quality standards, and operational excellence
                        </p>
                    </div>
                    <div style={{
                        textAlign: 'center',
                        padding: '20px',
                        border: "1px solid #e0e0e0",
                        borderRadius: '10px',
                        minWidth: isMobile ? '100%' : '200px',
                    }}>
                        <div style={{
                            fontSize: isMobile ? '36px' : '48px',
                            fontWeight: 'bold',
                            color: '#4CAF50',
                            marginBottom: '5px'
                        }}>
                            94%
                        </div>
                        <div style={{ 
                            fontSize: isMobile ? '14px' : '16px',
                            color: '#666'
                        }}>
                            Excellent Compliance
                        </div>
                        <div style={{
                            fontSize: '12px',
                            color: '#4CAF50',
                            marginTop: '5px',
                            fontWeight: 'bold'
                        }}>
                            ▲ 2% from last month
                        </div>
                    </div>
                </div>
                
                <div style={{ marginTop: '25px' }}>
                    <div style={{ marginBottom: '15px' }}>
                        <div style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between',
                            marginBottom: '5px'
                        }}>
                            <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
                                <FaUtensils aria-hidden="true" style={{ marginRight: '5px', color: '#4CAF50' }} />
                                Food Safety Standards
                            </span>
                            <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#4CAF50' }}>96%</span>
                        </div>
                        <div style={{
                            height: '10px',
                            backgroundColor: '#e0e0e0',
                            borderRadius: '5px',
                            overflow: 'hidden'
                        }}>
                            <div style={{
                                width: '96%',
                                height: '100%',
                                backgroundColor: '#4CAF50',
                                borderRadius: '5px'
                            }}></div>
                        </div>
                    </div>
                    
                    <div style={{ marginBottom: '15px' }}>
                        <div style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between',
                            marginBottom: '5px'
                        }}>
                            <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
                                <FaShieldAlt aria-hidden="true" style={{ marginRight: '5px', color: '#2196F3' }} />
                                Hygiene & Sanitation
                            </span>
                            <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#2196F3' }}>92%</span>
                        </div>
                        <div style={{
                            height: '10px',
                            backgroundColor: '#e0e0e0',
                            borderRadius: '5px',
                            overflow: 'hidden'
                        }}>
                            <div style={{
                                width: '92%',
                                height: '100%',
                                backgroundColor: '#2196F3',
                                borderRadius: '5px'
                            }}></div>
                        </div>
                    </div>
                    
                    <div style={{ marginBottom: '15px' }}>
                        <div style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between',
                            marginBottom: '5px'
                        }}>
                            <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
                                <FaStar aria-hidden="true" style={{ marginRight: '5px', color: '#FF9800' }} />
                                Quality Control
                            </span>
                            <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#FF9800' }}>91%</span>
                        </div>
                        <div style={{
                            height: '10px',
                            backgroundColor: '#e0e0e0',
                            borderRadius: '5px',
                            overflow: 'hidden'
                        }}>
                            <div style={{
                                width: '91%',
                                height: '100%',
                                backgroundColor: '#FF9800',
                                borderRadius: '5px'
                            }}></div>
                        </div>
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <div style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between',
                            marginBottom: '5px'
                        }}>
                            <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
                                <FaClipboardCheck aria-hidden="true" style={{ marginRight: '5px', color: '#9C27B0' }} />
                                Operational Excellence
                            </span>
                            <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#9C27B0' }}>88%</span>
                        </div>
                        <div style={{
                            height: '10px',
                            backgroundColor: '#e0e0e0',
                            borderRadius: '5px',
                            overflow: 'hidden'
                        }}>
                            <div style={{
                                width: '88%',
                                height: '100%',
                                backgroundColor: '#9C27B0',
                                borderRadius: '5px'
                            }}></div>
                        </div>
                    </div>
                </div>
            </div>

            <div style={{ 
                marginBottom: '10px',
                padding: '20px',
                borderRadius: '10px',
            }}>
                <h4 style={{ 
                    fontSize: isMobile ? '16px' : '18px',
                    color: '#333',
                    marginBottom: '15px',
                    textAlign: 'center'
                }}>
                    🍽️ Food & Beverages Compliance Categories
                </h4>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: isMobile ? '1fr' : 'repeat(4, 1fr)',
                    gap: '15px',
                    marginBottom: '20px'
                }}>
                    {[
                        { 
                            id: 'food-safety', 
                            name: 'Food Safety', 
                            description: 'Temperature control, storage, handling',
                            icon: <FaShieldAlt aria-hidden="true" />, 
                            color: '#4CAF50',
                            score: '96%'
                        },
                        { 
                            id: 'hygiene', 
                            name: 'Hygiene Standards', 
                            description: 'Staff hygiene, sanitation, cleaning',
                            icon: <FaUsers aria-hidden="true" />, 
                            color: '#2196F3',
                            score: '92%'
                        },
                        { 
                            id: 'quality', 
                            name: 'Quality Control', 
                            description: 'Ingredients, preparation, consistency',
                            icon: <FaStar aria-hidden="true" />, 
                            color: '#FF9800',
                            score: '91%'
                        },
                        { 
                            id: 'operations', 
                            name: 'Operations', 
                            description: 'Service, documentation, training',
                            icon: <FaClipboardCheck aria-hidden="true" />, 
                            color: '#9C27B0',
                            score: '88%'
                        }
                    ].map(category => (
                        <div 
                            key={category.id}
                            style={{
                                padding: '20px',
                                borderRadius: '8px',
                                textAlign: 'center',
                                border: `1px solid ${category.color}`,
                                transition: 'all 0.3s ease',
                                cursor: 'pointer'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-5px)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                            }}
                            onClick={() => alert(`View ${category.name} details`)}
                        >
                            <div style={{ 
                                fontSize: '32px', 
                                color: category.color,
                                marginBottom: '15px'
                            }}>
                                {category.icon}
                            </div>
                            <div style={{ 
                                fontSize: isMobile ? '16px' : '18px',
                                fontWeight: 'bold',
                                color: '#333',
                                marginBottom: '8px'
                            }}>
                                {category.name}
                            </div>
                            <div style={{ 
                                fontSize: isMobile ? '12px' : '13px',
                                color: '#666',
                                marginBottom: '15px',
                                minHeight: '40px'
                            }}>
                                {category.description}
                            </div>
                            <div style={{
                                fontSize: '24px',
                                fontWeight: 'bold',
                                color: category.color,
                                padding: '8px',
                                borderRadius: '6px'
                            }}>
                                {category.score}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div style={{ 
                display: 'grid', 
                gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)', 
                gap: '20px', 
                marginBottom: '10px' 
            }}>
                {[
                    { 
                        title: "Temperature Control", 
                        status: "compliant", 
                        score: "98%",
                        icon: <FaCheckCircle aria-hidden="true" />,
                        color: "#4CAF50",
                        lastCheck: "Today",
                        details: "Refrigeration, cooking, holding temperatures",
                        trend: "▲ 1%"
                    },
                    { 
                        title: "Staff Hygiene", 
                        status: "compliant", 
                        score: "95%",
                        icon: <FaClipboardCheck aria-hidden="true" />,
                        color: "#4CAF50",
                        lastCheck: "2 days ago",
                        details: "Hand washing, uniform, health checks",
                        trend: "▲ 2%"
                    },
                    { 
                        title: "Ingredient Quality", 
                        status: "compliant", 
                        score: "96%",
                        icon: <FaStar aria-hidden="true" />,
                        color: "#4CAF50",
                        lastCheck: "Yesterday",
                        details: "Freshness, sourcing, storage",
                        trend: "▲ 3%"
                    },
                    { 
                        title: "Food Storage", 
                        status: "pending", 
                        score: "88%",
                        icon: <FaClock aria-hidden="true" />,
                        color: "#FFC107",
                        lastCheck: "1 week ago",
                        details: "FIFO, labeling, segregation",
                        trend: "▼ 2%"
                    },
                    { 
                        title: "Preparation Standards", 
                        status: "compliant", 
                        score: "94%",
                        icon: <FaCheckCircle aria-hidden="true" />,
                        color: "#4CAF50",
                        lastCheck: "3 days ago",
                        details: "Cooking methods, cross-contamination",
                        trend: "▲ 1%"
                    },
                    { 
                        title: "Cleaning Procedures", 
                        status: "attention", 
                        score: "82%",
                        icon: <FaExclamationCircle aria-hidden="true" />,
                        color: "#f44336",
                        lastCheck: "2 weeks ago",
                        details: "Sanitization, equipment cleaning",
                        trend: "▼ 5%"
                    }
                ].map((item, index) => (
                    <div 
                        key={index} 
                        style={{
                            backgroundColor: "#fff",
                            borderRadius: "8px",
                            padding: "15px",
                            minHeight: "100px",
                            border: "1px solid #e0e0e0",
                            borderLeft: `5px solid ${item.color}`,
                            transition: 'all 0.3s ease',
                            cursor: 'pointer',
                            position: 'relative'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-5px)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                        }}
                        onClick={() => alert(`View details for ${item.title}`)}
                    >
                        <div style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            alignItems: 'flex-start',
                            marginBottom: '15px'
                        }}>
                            <div style={{ flex: 1 }}>
                                <h5 style={{ 
                                    margin: '0 0 5px 0', 
                                    color: '#333',
                                    fontSize: isMobile ? '14px' : '16px',
                                    fontWeight: 'bold'
                                }}>
                                    {item.title}
                                </h5>
                                <div style={{ 
                                    display: 'flex', 
                                    alignItems: 'center',
                                    marginBottom: '5px'
                                }}>
                                    <span style={{ 
                                        color: item.color,
                                        fontWeight: 'bold',
                                        fontSize: isMobile ? '18px' : '22px',
                                        marginRight: '10px'
                                    }}>
                                        {item.score}
                                    </span>
                                    <span style={{ 
                                        color: item.color,
                                        padding: '3px 8px',
                                        borderRadius: '12px',
                                        fontSize: '11px',
                                        fontWeight: 'bold',
                                        textTransform: 'uppercase'
                                    }}>
                                        {item.status}
                                    </span>
                                </div>
                                <div style={{ 
                                    fontSize: '12px',
                                    color: '#666',
                                    marginTop: '8px',
                                    lineHeight: '1.4'
                                }}>
                                    {item.details}
                                </div>
                            </div>
                            <div style={{ 
                                fontSize: '24px', 
                                color: item.color,
                                marginLeft: '10px'
                            }}>
                                {item.icon}
                            </div>
                        </div>
                        
                        <div style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            fontSize: '12px',
                            color: '#666',
                            marginTop: '15px',
                            paddingTop: '10px',
                            borderTop: '1px solid #f0f0f0'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <FaRegCalendarAlt aria-hidden="true" style={{ marginRight: '5px', fontSize: '10px' }} />
                                Checked: {item.lastCheck}
                            </div>
                            <div style={{
                                color: item.trend.startsWith('▲') ? '#4CAF50' : 
                                       item.trend.startsWith('▼') ? '#f44336' : '#666',
                                fontWeight: 'bold'
                            }}>
                                {item.trend}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div style={{ 
                padding: '25px', 
                borderRadius: '12px',
                marginBottom: '10px',
            }}>
                <h4 style={{ 
                    fontSize: isMobile ? '18px' : '20px',
                    color: '#1565c0',
                    marginBottom: '20px',
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    <FaCalendarCheck aria-hidden="true" style={{ marginRight: '10px' }} />
                    Upcoming Food Safety Audits & Inspections
                </h4>
                
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
                    gap: '15px'
                }}>
                    {[
                        { 
                            title: "FSSAI Annual Inspection", 
                            date: "2024-04-15", 
                            status: "scheduled",
                            type: "Regulatory",
                            priority: "high",
                            inspector: "Food Safety Officer",
                            location: "Main Kitchen"
                        },
                        { 
                            title: "Kitchen Hygiene Audit", 
                            date: "2024-04-22", 
                            status: "scheduled",
                            type: "Internal",
                            priority: "medium",
                            inspector: "Quality Manager",
                            location: "All Areas"
                        },
                        { 
                            title: "Staff Training Assessment", 
                            date: "2024-05-01", 
                            status: "pending",
                            type: "Training",
                            priority: "medium",
                            inspector: "Training Department",
                            location: "Training Room"
                        },
                        { 
                            title: "Supplier Quality Review", 
                            date: "2024-05-10", 
                            status: "planned",
                            type: "Vendor",
                            priority: "high",
                            inspector: "Procurement Team",
                            location: "Storage & Kitchen"
                        }
                    ].map((audit, index) => (
                        <div 
                            key={index}
                            style={{
                                padding: '20px',
                                borderRadius: '8px',
                                border: '1px solid #e0e0e0'
                            }}
                        >
                            <div style={{ 
                                display: 'flex', 
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                                marginBottom: '10px',
                                flexDirection: isMobile ? 'column' : 'row',
                                gap: isMobile ? '8px' : '0'
                            }}>
                                <div style={{ flex: 1 }}>
                                    <h6 style={{ 
                                        margin: 0,
                                        fontSize: isMobile ? '14px' : '16px',
                                        fontWeight: 'bold',
                                        color: '#333',
                                        lineHeight: '1.3'
                                    }}>
                                        {audit.title}
                                    </h6>
                                    <div style={{ 
                                        fontSize: isMobile ? '11px' : '12px',
                                        color: '#666',
                                        marginTop: isMobile ? '3px' : '5px'
                                    }}>
                                        <div>Inspector: {audit.inspector}</div>
                                        <div>Location: {audit.location}</div>
                                    </div>
                                </div>
                                <span style={{ 
                                    color: audit.status === 'scheduled' ? '#2e7d32' : 
                                           audit.status === 'pending' ? '#FF9800' : '#2196F3',
                                    padding: '4px 10px',
                                    borderRadius: '12px',
                                    fontSize: isMobile ? '10px' : '12px',
                                    fontWeight: 'bold',
                                    whiteSpace: 'nowrap',
                                    alignSelf: isMobile ? 'flex-start' : 'center'
                                }}>
                                    {audit.status.toUpperCase()}
                                </span>
                            </div>
                            <div style={{ 
                                display: 'flex', 
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                fontSize: isMobile ? '11px' : '13px',
                                color: '#666',
                                marginTop: '15px',
                                flexDirection: isMobile ? 'column' : 'row',
                                gap: isMobile ? '8px' : '0',
                                alignItems: isMobile ? 'flex-start' : 'center'
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <FaRegCalendarAlt aria-hidden="true" style={{ marginRight: '8px', fontSize: isMobile ? '12px' : '14px' }} />
                                    <strong>Date:</strong> {audit.date}
                                </div>
                                <div style={{ alignSelf: isMobile ? 'flex-start' : 'center' }}>
                                    <span style={{ 
                                        color: audit.priority === 'high' ? '#f44336' : 
                                               audit.priority === 'medium' ? '#FF9800' : '#4CAF50',
                                        padding: '4px 8px',
                                        borderRadius: '10px',
                                        fontSize: isMobile ? '10px' : '11px',
                                        fontWeight: 'bold',
                                        display: 'inline-block',
                                        textAlign: 'center'
                                    }}>
                                        {audit.type} | {audit.priority.toUpperCase()} PRIORITY
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div style={{ 
                padding: '25px', 
                borderRadius: '12px',
                marginBottom: '10px',
            }}>
                <h4 style={{ 
                    fontSize: isMobile ? '18px' : '20px',
                    color: '#e65100',
                    marginBottom: '20px',
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    <FaClipboardCheck aria-hidden="true" style={{ marginRight: '10px' }} />
                    Required Actions for Food Safety Compliance
                </h4>
                
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
                    gap: '15px',
                    marginBottom: '20px'
                }}>
                    <div style={{ padding: '20px', borderRadius: '8px', border: '1px solid #e0e0e0' }}>
                        <div style={{ 
                            display: 'flex', 
                            alignItems: 'center',
                            marginBottom: '15px'
                        }}>
                            <FaExclamationTriangle aria-hidden="true" style={{ color: '#f44336', marginRight: '10px', fontSize: '20px' }} />
                            <strong style={{ color: '#f44336', fontSize: isMobile ? '14px' : '16px' }}>
                                Immediate Attention Required (Within 48 hours)
                            </strong>
                        </div>
                        <ul style={{ paddingLeft: '20px', fontSize: '14px', margin: 0 }}>
                            <li style={{ marginBottom: '8px', paddingLeft: '10px' }}>
                                <strong>Deep Cleaning Schedule:</strong> Complete overdue deep cleaning of walk-in refrigerator
                            </li>
                            <li style={{ marginBottom: '8px', paddingLeft: '10px' }}>
                                <strong>Temperature Logs:</strong> Submit missing temperature logs for March 15-20
                            </li>
                            <li style={{ marginBottom: '8px', paddingLeft: '10px' }}>
                                <strong>Staff Training:</strong> 2 kitchen staff need food handler certification renewal
                            </li>
                            <li style={{ paddingLeft: '10px' }}>
                                <strong>Equipment Calibration:</strong> Calibrate meat thermometer by tomorrow
                            </li>
                        </ul>
                    </div>
                    
                    <div style={{ padding: '20px', borderRadius: '8px', border: '1px solid #e0e0e0' }}>
                        <div style={{ 
                            display: 'flex', 
                            alignItems: 'center',
                            marginBottom: '15px'
                        }}>
                            <FaClock aria-hidden="true" style={{ color: '#FF9800', marginRight: '10px', fontSize: '20px' }} />
                            <strong style={{ color: '#FF9800', fontSize: isMobile ? '14px' : '16px' }}>
                                Upcoming Compliance Deadlines
                            </strong>
                        </div>
                        <ul style={{ paddingLeft: '20px', fontSize: '14px', margin: 0 }}>
                            <li style={{ marginBottom: '8px', paddingLeft: '10px' }}>
                                <strong>Q1 Safety Report:</strong> Due April 30, 2024
                            </li>
                            <li style={{ marginBottom: '8px', paddingLeft: '10px' }}>
                                <strong>Pest Control Service:</strong> Scheduled for May 5, 2024
                            </li>
                            <li style={{ marginBottom: '8px', paddingLeft: '10px' }}>
                                <strong>Fire Safety Inspection:</strong> Due May 15, 2024
                            </li>
                            <li style={{ paddingLeft: '10px' }}>
                                <strong>Annual Staff Health Check:</strong> Due June 1, 2024
                            </li>
                        </ul>
                    </div>
                </div>
                
                <div style={{ textAlign: 'center' }}>
                    <button 
                        onClick={() => alert("Generated Food Safety Report successfully")}
                        style={{
                            backgroundColor: '#4CAF50',
                            color: 'white',
                            border: 'none',
                            padding: isMobile ? '10px 20px' : '15px 40px',
                            borderRadius: '50px',
                            cursor: 'pointer',
                            fontSize: isMobile ? '14px' : '16px',
                            fontWeight: 'bold',
                            minWidth: isMobile ? '200px' : '250px',
                            maxWidth: isMobile ? '90%' : 'none',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'all 0.3s ease',
                            boxShadow: '0 4px 15px rgba(76, 175, 80, 0.3)',
                            height: isMobile ? '45px' : '50px'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#388E3C';
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = '0 6px 20px rgba(76, 175, 80, 0.4)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = '#4CAF50';
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 4px 15px rgba(76, 175, 80, 0.3)';
                        }}
                    >
                        <FaChartBar aria-hidden="true" style={{ marginRight: '10px', fontSize: isMobile ? '16px' : '18px' }} />
                        Generate Compliance Report
                    </button>
                </div>
            </div>

            <div style={{ 
                padding: '15px', 
                borderRadius: '12px',
                marginBottom: '10px',
            }}>
                <h4 style={{ 
                    fontSize: isMobile ? '18px' : '20px',
                    color: '#7b1fa2',
                    marginBottom: '20px',
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    <FaChartLine aria-hidden="true" style={{ marginRight: '10px' }} />
                    Food Safety Performance Metrics
                </h4>
                
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
                    gap: '15px'
                }}>
                    <div style={{ 
                        textAlign: 'center', 
                        padding: '20px', 
                        borderRadius: '8px',
                        border: '1px solid #e0e0e0'
                    }}>
                        <div style={{ fontSize: isMobile ? '28px' : '32px', color: '#4CAF50', fontWeight: 'bold', marginBottom: '10px' }}>0</div>
                        <div style={{ fontSize: isMobile ? '12px' : '14px', color: '#666', marginBottom: '5px' }}>Critical Violations</div>
                        <div style={{ fontSize: '12px', color: '#4CAF50', fontWeight: 'bold' }}>This Month</div>
                    </div>
                    <div style={{ 
                        textAlign: 'center', 
                        padding: '20px', 
                        borderRadius: '8px',
                        border: '1px solid #e0e0e0'
                    }}>
                        <div style={{ fontSize: isMobile ? '28px' : '32px', color: '#2196F3', fontWeight: 'bold', marginBottom: '10px' }}>3</div>
                        <div style={{ fontSize: isMobile ? '12px' : '14px', color: '#666', marginBottom: '5px' }}>Minor Violations</div>
                        <div style={{ fontSize: '12px', color: '#2196F3', fontWeight: 'bold' }}>Resolving</div>
                    </div>
                    <div style={{ 
                        textAlign: 'center', 
                        padding: '20px', 
                        borderRadius: '8px',
                        border: '1px solid #e0e0e0'
                    }}>
                        <div style={{ fontSize: isMobile ? '28px' : '32px', color: '#FF9800', fontWeight: 'bold', marginBottom: '10px' }}>12</div>
                        <div style={{ fontSize: isMobile ? '12px' : '14px', color: '#666', marginBottom: '5px' }}>Completed Audits</div>
                        <div style={{ fontSize: '12px', color: '#FF9800', fontWeight: 'bold' }}>Last 90 Days</div>
                    </div>
                    <div style={{ 
                        textAlign: 'center', 
                        padding: '20px', 
                        borderRadius: '8px',
                        border: '1px solid #e0e0e0'
                    }}>
                        <div style={{ fontSize: isMobile ? '28px' : '32px', color: '#9C27B0', fontWeight: 'bold', marginBottom: '10px' }}>94%</div>
                        <div style={{ fontSize: isMobile ? '12px' : '14px', color: '#666', marginBottom: '5px' }}>Compliance Score</div>
                        <div style={{ fontSize: '12px', color: '#9C27B0', fontWeight: 'bold' }}>Industry Average: 89%</div>
                    </div>
                </div>
            </div>

            <div style={{ 
                padding: '25px', 
                borderRadius: '12px',
                textAlign: 'center'
            }}>
                <h4 style={{ 
                    fontSize: isMobile ? '18px' : '20px',
                    color: '#2e7d32',
                    marginBottom: '15px'
                }}>
                    🏆 Compliance Excellence Recognition
                </h4>
                <p style={{ fontSize: isMobile ? '14px' : '16px', color: '#333', marginBottom: '20px' }}>
                    Your establishment maintains <strong>94% compliance score</strong>, placing you in the <strong>top 15%</strong> 
                    of Food & Beverage businesses on our platform. Keep up the excellent work!
                </p>
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '20px',
                    flexWrap: 'wrap'
                }}>
                    <div style={{ 
                        padding: '15px', 
                        borderRadius: '8px',
                        minWidth: isMobile ? '130px' : '150px',
                        border: '1px solid #e0e0e0'
                    }}>
                        <div style={{ fontSize: '12px', color: '#666', marginBottom: '5px' }}>Current Streak</div>
                        <div style={{ fontSize: '24px', color: '#4CAF50', fontWeight: 'bold' }}>180</div>
                        <div style={{ fontSize: '12px', color: '#666' }}>Days without violations</div>
                    </div>
                    <div style={{ 
                        padding: '15px', 
                        borderRadius: '8px',
                        minWidth: isMobile ? '130px' : '150px',
                        border: '1px solid #e0e0e0'
                    }}>
                        <div style={{ fontSize: '12px', color: '#666', marginBottom: '5px' }}>Industry Rank</div>
                        <div style={{ fontSize: '24px', color: '#4CAF50', fontWeight: 'bold' }}>Top 15%</div>
                        <div style={{ fontSize: '12px', color: '#666' }}>Among 500+ restaurants</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ComplianceStatus;